import React from 'react';

const PrivacyPolicy: React.FC = () => (
  <div style={{ maxWidth: 800, margin: '0 auto', padding: '2rem' }}>
    <h1>Política de Privacidad</h1>
    <p>
      En Lucods, valoramos tu privacidad. Esta política explica cómo recopilamos, usamos y protegemos tu información personal cuando visitas nuestro sitio web.
    </p>
    <h2>Información que recopilamos</h2>
    <ul>
      <li>Datos de uso del sitio web (cookies y tecnologías similares).</li>
      <li>Información proporcionada por el usuario a través de formularios de contacto.</li>
    </ul>
    <h2>Uso de la información</h2>
    <ul>
      <li>Mejorar la experiencia del usuario.</li>
      <li>Analizar el tráfico y uso del sitio.</li>
      <li>Responder a consultas o solicitudes.</li>
    </ul>
    <h2>Cookies</h2>
    <p>
      Utilizamos cookies para analizar el tráfico y mejorar tu experiencia. Puedes aceptar o rechazar el uso de cookies no esenciales.
    </p>
    <h2>Cookies y preferencias</h2>
    <p>
      Puedes aceptar, rechazar o personalizar el uso de cookies no esenciales (análisis y marketing) en cualquier momento. Para cambiar tus preferencias, haz clic en el botón de configuración de cookies disponible en la parte inferior del sitio o vuelve a abrir el banner de consentimiento.
    </p>
    <p>
      Las cookies esenciales son necesarias para el funcionamiento del sitio y no pueden ser desactivadas.
    </p>
    <h2>Compartir información</h2>
    <p>
      No compartimos tu información personal con terceros, salvo cuando sea necesario para cumplir con obligaciones legales.
    </p>
    <h2>Tus derechos</h2>
    <p>
      Puedes solicitar acceso, rectificación o eliminación de tus datos personales contactándonos a través de nuestro formulario.
    </p>
    <h2>Contacto</h2>
    <p>
      Si tienes preguntas sobre esta política, contáctanos a través de nuestro formulario de contacto.
    </p>
    <p>
      Última actualización: Julio 2025
    </p>
  </div>
);

export default PrivacyPolicy;
